export default class CounselingService {
  constructor(http) {
    this.http = http;
  }

  async findAllCounselingWithUserAndRegi(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/counseling/readall?${queryParams}`, {
      method: "GET",
    });
  }

  async createCounseling(counseling) {
    return this.http.fetch(`/api/counseling/create`, {
      method: "POST",
      body: JSON.stringify(counseling),
    });
  }

  async updateCounseling(counseling) {
    return this.http.fetch(`/api/counseling/update`, {
      method: "PUT",
      body: JSON.stringify(counseling),
    });
  }

  async deleteCounseling(id) {
    return this.http.fetch(`/api/counseling/delete`, {
      method: "DELETE",
      body: JSON.stringify({ id }),
    });
  }
}
